// extracted by mini-css-extract-plugin
module.exports = {"Links":"Links_Links__3YpO4","Links_item":"Links_Links_item__LtE3-","heb":"Links_heb__2FXXA"};